<template>
  <main id="main" style="padding-bottom: 100px;">
    <div class="container">
      <div class="form">
        <div class="row">
          <div class="col">
            <div class="section-header">
              <h2>Fees</h2>
            </div>
          </div>
        </div>
        <div v-if="checkAccess" class="row">
          <div class="col">
            <listingFee />
          </div>
        </div>
        <div v-else class="row">
          <div class="col">
            <alert
              :text="'You don\'t have permission to view this page'"
              :type="'ERROR'"
            />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
/* eslint-disable */
import Log from '../../../assets/Log'
import alert from '../../shared/alert'
import listingFee from './listingFee'

export default {
  components: {
    listingFee,
    alert,
  },
  computed: {
    checkAccess() {
      if (Log.getUser().role === 'Super Admin') {
        return true
      } else {
        return false
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
